import { PayloadAction } from "@reduxjs/toolkit";
import { Page } from "../../../../utl/models/Page";
import { ClientsState } from "../models/ClientsState";

const setPageClientsTransactions = (state: ClientsState, action: PayloadAction<Page>) => {
    state.clientsPages.page = action.payload.page;
}

export default setPageClientsTransactions;